import { useMutation } from "react-query";
import completeOnboarding from "../services/completeOnboarding";

function useCompleteOnboarding() {
  return useMutation(["complete-onboarding"], completeOnboarding);
}

export default useCompleteOnboarding;
